<template>
  <header class="app-header navbar">
    <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <b-link class="navbar-brand" to="#"></b-link>
    <button class="navbar-toggler sidebar-toggler d-md-down-none" type="button" @click="sidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <b-navbar-nav class="d-md-down-none">
      <!-- <b-nav-item class="px-3">{{ $store.getters.instituicao }}</b-nav-item> -->
      <!-- <b-nav-item class="px-3">Users</b-nav-item>
      <b-nav-item class="px-3">Settings</b-nav-item> -->
    </b-navbar-nav>
    <b-navbar-nav class="ml-auto">
      <usuario-header></usuario-header>
      <!-- <b-nav-item class="px-3">{{ $store.getters.usuario }} - <strong>[{{ $store.getters.instituicaoSigla }}]</strong></b-nav-item> -->
      <!-- <b-nav-item-dropdown right>
        <template slot="button-content">
          {{ $store.getters.usuario }} - <strong>[{{ $store.getters.instituicaoSigla }}]</strong>
        </template>
        <b-dropdown-item href="#">Trocar Senha</b-dropdown-item>
      </b-nav-item-dropdown> -->
      <b-nav-item class="px-3"><i class="fa fa-sign-out fa-lg icon-button" @click="sair()" title="Sair"></i></b-nav-item>
     <!--  <b-nav-item class="d-md-down-none">
        <i class="icon-bell"></i>
        <b-badge pill variant="danger">5</b-badge>
      </b-nav-item>
      <b-nav-item class="d-md-down-none">
        <i class="icon-list"></i>
      </b-nav-item>
      <b-nav-item class="d-md-down-none">
        <i class="icon-location-pin"></i>
      </b-nav-item>
      <HeaderDropdown/> -->
    </b-navbar-nav>
    <!-- <button class="navbar-toggler aside-menu-toggler d-md-down-none" type="button" @click="asideToggle">
      <span class="navbar-toggler-icon"></span>
    </button> -->
  </header>
</template>

<script>
  import UsuarioHeader from './../../../modulos/login/UsuarioHeader'

  export default {
    name: 'c-header',
    components: {
      UsuarioHeader
    },
    methods: {
      sidebarToggle (e) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-hidden')
      },
      sidebarMinimize (e) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-minimized')
      },
      mobileSidebarToggle (e) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-mobile-show')
      },
      asideToggle (e) {
        e.preventDefault()
        document.body.classList.toggle('aside-menu-hidden')
      },
      sair () {
        this.$store.dispatch('logout')
        this.$router.push('/login')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/layout/components/Header/Header.vue